import React from 'react';
import TemplatePage from '../../../components/templatePage';
import { useDispatch, useSelector } from 'react-redux';
import { setGetCreditHisotry } from '../../store/thunk/setGetCreditHistory';
import HistoryItem from '../../components/historyItem';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const handleLoadPagination = ({page, setPage, countPage, dispatch}) => {
    if (page <= countPage) {
        dispatch(setGetCreditHisotry({
            page: page + 1,
            rowsPerPage: 10,
            search: ''
        }));
        setPage(page + 1);
    }
}

const handleLoading = (dispatch) => {
    dispatch(setLoadingAction(true))
}

const HistoryCredit = () => {
    const dispatch = useDispatch();
    const [page, setPage] = React.useState(1);

    React.useEffect(() => {
        dispatch(setGetCreditHisotry({
            page: 1,
            rowsPerPage: 10,
            search: ''
        }))
    }, [])

    const list = useSelector(state => state.creditMobile.history);

    if (!list.list.length) {
        return <>loading</>
    }

    return (
        <TemplatePage
            title="История о выданных кредитах"
            pagination={page < list.page && list.list.length}
            handleLoadPagination={() => handleLoadPagination({
                page,
                setPage,
                countPage: list.page,
                dispatch
            })}
            handleLoading={() => handleLoading(dispatch)}
        >
            {
                list.list.map((item, key) => <HistoryItem item={item} key={key} />)
            }
        </TemplatePage>
    )
}

export default HistoryCredit;